import { useTranslation } from "react-i18next"

import "./LeagueFrame.css"

/* The frame a player's league draws round their icon (owner, 2026-10-08): in the lobby seat, on
   the hall of fame's cards and on the screen that opens a game. Each league above the last is more
   of an event than the one below it, because reaching it is: Bronze is a plain bevel, Silver
   catches the light, Gold is plated and riveted, Diamond turns through its colours and sparkles,
   and a Commander's frame burns, wears a crown and throws embers.

   It knows nothing but the league id (`PublicUserSerializer.league`, the server's conversion), and
   draws nothing for none — a server from before the leagues. A bot is in no league, and wears a
   plain black frame where a person wears theirs (owner, 2026-10-09: "a black frame for bots
   everywhere"), with no plate: there is no league to name. Every moving part stops under "reduce
   motion" (LeagueFrame.css). */
const SIZES = ["sm", "md", "lg"]

const Crown = () => (
  <svg className="league-frame-crown" viewBox="0 0 24 16" aria-hidden="true">
    <path d="M2 14 L4 4 L8.5 9 L12 1.5 L15.5 9 L20 4 L22 14 Z" />
    <circle cx="4" cy="3.6" r="1.6" />
    <circle cx="12" cy="1.4" r="1.6" />
    <circle cx="20" cy="3.6" r="1.6" />
  </svg>
)

const LeagueFrame = ({ league, bot = false, size = "md", tag = true, className = "", children }) => {
  const { t } = useTranslation()
  const frame = bot ? "bot" : league
  const plate = tag && !bot
  if (!frame) return children
  const sized = SIZES.includes(size) ? size : "md"
  return (
    <span
      className={`league-frame league-frame-${frame} league-frame-${sized} ${className}`.trim()}
      data-league={frame}
      title={bot ? undefined : t(`ranking.leagues.${league}`)}
    >
      <span className="league-frame-ring" aria-hidden="true" />
      <span className="league-frame-art">{children}</span>
      {(league === "gold" || league === "diamond" || league === "commander") && (
        <span className="league-frame-rivets" aria-hidden="true">
          <i />
          <i />
          <i />
          <i />
        </span>
      )}
      {(league === "diamond" || league === "commander") && (
        <span className="league-frame-sparks" aria-hidden="true">
          <i />
          <i />
          <i />
          <i />
          <i />
        </span>
      )}
      {league === "commander" && <Crown />}
      {plate && <span className="league-frame-tag">{t(`ranking.leagues.${league}`)}</span>}
    </span>
  )
}

export default LeagueFrame
